import { Trans } from 'react-i18next';
import { StatusMapItem } from 'src/components/StatusView/StatusView';
import { ApplicationStatus } from 'src/stores/ApplicationsStore/ApplicationsStore.types';
import { CssColors } from 'src/styles/CssVariables';

export const applicationsStatusInfoMap: StatusMapItem[] = [
    // Neutral & Review States (grayscale)
    {
        status: ApplicationStatus.ASSIGNED,
        label: <Trans i18nKey="Data.ApplicationStatus.ASSIGNED" />,
        color: CssColors.textBlack,
        backgroundColor: CssColors.fillGrey,
        borderColor: CssColors.borderMediumGrey,
    },
    {
        status: ApplicationStatus.PENDING_ASSIGNMENT,
        label: <Trans i18nKey="Data.ApplicationStatus.PENDING_ASSIGNMENT" />,
        color: CssColors.textBlack,
        backgroundColor: CssColors.fillGrey,
        borderColor: CssColors.borderMediumGrey,
    },
    {
        status: ApplicationStatus.RETURNED_FOR_ASSIGNMENT,
        label: (
            <Trans i18nKey="Data.ApplicationStatus.RETURNED_FOR_ASSIGNMENT" />
        ),
        color: CssColors.textBlack,
        backgroundColor: CssColors.fillGrey,
        borderColor: CssColors.borderMediumGrey,
    },
    // Active & Final States (high-contrast)
    {
        status: ApplicationStatus.DECLINED,
        label: <Trans i18nKey="Data.ApplicationStatus.DECLINED" />,
        color: CssColors.textWhite,
        backgroundColor: CssColors.red,
        borderColor: CssColors.red,
    },
    {
        status: ApplicationStatus.ACTIVE,
        label: <Trans i18nKey="Data.ApplicationStatus.ACTIVE" />,
        color: CssColors.textWhite,
        backgroundColor: CssColors.green,
        borderColor: CssColors.green,
    },
    {
        status: ApplicationStatus.FULLY_PAID,
        label: <Trans i18nKey="Data.ApplicationStatus.FULLY_REPAID" />,
        color: CssColors.textWhite,
        backgroundColor: CssColors.pureBlack,
        borderColor: CssColors.pureBlack,
    },
];
